import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { getProductById } from "../../../apis/product";

const ViewProduct = () => {
  const [formData, setFormData] = useState<any>();

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const rawData = queryParams.get("EmployeeData");
  if (rawData) {
    console.error(JSON.parse(rawData), "rawdata");
  }

  const productDetails = async () => {
    try {
      const response = await getProductById(rawData);
      setFormData(response);
    } catch (error) {
      console.error("error");
    }
  };

  useEffect(() => {
    productDetails();
  });

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {formData && (
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h2>View Form</h2>
                <div className="container mt-5">
                  <form>
                    <div className="raw-div-1">
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                          Full Name
                        </label>
                        <input
                          type="full_name"
                          className="form-control"
                          id="name"
                          name="name"
                          value={formData.name}
                          disabled
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="rate" className="form-label">
                          Rate
                        </label>
                        <input
                          type="rate"
                          className="form-control"
                          id="rate"
                          name="rate"
                          value={formData.rate}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="raw-div-2">
                      <div className="mb-3">
                        <label htmlFor="rate" className="form-label">
                          About vendor
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="model_no"
                          name="model_no"
                          value={formData.model_no}
                          disabled
                        />
                      </div>
                      {/* <div className="mb-3">
                    <label htmlFor="rate" className="form-label">
                      Company
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="company"
                      name="company"
                      value={formData.company}
                      
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="rate" className="form-label">
                      About
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="about"
                      name="about"
                      value={formData.about}
                      
                    />
                  </div> */}
                      <div className="mb-3">
                        <label htmlFor="address" className="form-label">
                          Address
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="address"
                          name="address"
                          value={formData.address}
                          disabled
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="geo_location" className="form-label">
                          Geo Location
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="geo_location"
                          name="geo_location"
                          value={formData.geo_location}
                          disabled
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewProduct;
